import { ListingsSorting } from './listingsSorting'

export const SORTING_OPTIONS: ListingsSorting[] = [
  ListingsSorting.MostRecent,
  ListingsSorting.LeastRecent,
  ListingsSorting.MostExpensive,
  ListingsSorting.LeastExpensive,
]

export const SORTING_LABELS: Record<ListingsSorting, string> = {
  [ListingsSorting.MostRecent]: 'Chat.Sorting.MostRecent',
  [ListingsSorting.LeastRecent]: 'Chat.Sorting.LeastRecent',
  [ListingsSorting.MostExpensive]: 'Chat.Sorting.MostExpensive',
  [ListingsSorting.LeastExpensive]: 'Chat.Sorting.LeastExpensive',
}
